export const QueryKey = {
  accounts: {
    forgotPassword: 'accounts/forgot-password',
    login: 'accounts/login',
    register: 'accounts',
    sendVerification: 'send_verification',
    resetPassword: 'accounts/reset-password',
    resetPasswordTarget: 'accounts/reset-password-target',
  },
  user: {
    emailChange: 'request_user_email_change',
    deleteAccount: 'delete_user_account',
  },
  widgetSettings: 'widget-settings',
  widgetTranslations: {
    list: 'widget-translations',
    upsert: 'widget-translations-upsert',
    create: 'widget-translations-create',
    delete: 'widget-translations-delete',
    generate: 'widget-translations-generate',
  },
  installInstructions: {
    send: 'install_instructions_send',
  },
  emailSummaries: {
    activitySummary: {
      get: 'email-summaries-activity-summary',
      patch: 'email-summaries-activity-summary-patch',
    },
    marketingConsent: {
      get: 'email-summaries-marketing-consent',
      patch: 'email-summaries-marketing-consent-patch',
    },
  },
  conversationStarters: {
    generate: 'generate-conversation-starters',
  },
  chatPageAccess: {
    get: 'get_chat_page_access',
    patch: 'patch_chat_page_access',
  },
  inboxAutoCloseSettings: {
    get: 'get_inbox_auto_close_settings',
    patch: 'patch_inbox_auto_close_settings',
  },
  inboxConversationBadge: {
    get: 'get_inbox_conversation_badge',
    patch: 'patch_inbox_conversation_badge',
  },
  changelog: {
    list: 'changelog_list',
  },
  knowledgeBase: {
    get: 'knowledge_base',
    articles: {
      listOrFilter: 'articles',
      refresh: 'refresh_article',
      refreshAll: 'refresh_all_url_articles',
      autoTag: 'auto_tag_article',
      autoTagBulk: 'auto_tag_articles_bulk',
      autoRefresh: 'article_auto_refresh',
      autoRefreshBulk: 'article_auto_refresh_bulk',
    },
    autoRefresh: 'kb_auto_refresh',
    retryFailedEmbeds: 'retry_failed_embeds',
    article: 'article',
    articlesInfinite: 'knowledge-base-articles',
    articleDelete: 'article-delete',
    articlesWebsite: 'articles-website',
    articlesPdf: 'articles-pdf',
    syncedSites: {
      list: 'synced_sites',
      update: 'synced_sites_update',
      scope: 'synced_site_scope',
      scopeChildren: 'synced_site_scope_children',
      scopeUpdate: 'synced_site_scope_update',
      recentAdditions: 'synced_site_recent_additions',
      missingPages: 'synced_site_missing_pages',
      sync: 'synced_site_sync',
    },
    tags: 'knowledge_base_tags',
    tagsSearch: 'knowledge_base_tags_search',
    import: {
      youtubeVideo: 'import_youtube_video',
      scrape: {
        single: 'single_url',
        multiple: 'multiple_urls',
      },
    },
    siteMapPreview: {
      get: 'site_map_preview',
      start: 'site_map_preview_start',
      selection: 'site_map_preview_selection',
      scrape: 'site_map_preview_scrape',
      children: 'site_map_preview_children',
      delete: 'site_map_preview_delete',
    },
    intercom: {
      import: 'import_intercom_articles',
      refresh: 'refresh_intercom_articles',
      delete: 'delete_intercom_articles',
    },
  },
  sonyAdmin: {
    documents: 'sony_admin_documents',
    document: 'sony_admin_document',
    documentPatch: 'sony_admin_document_patch',
    runPipeline: 'sony_admin_run_pipeline',
    articlePatch: 'sony_admin_article_patch',
    deployLive: 'sony_admin_deploy_live',
  },
  campaign: {
    list: 'campaigns_list',
    get: 'campaign_get',
    update: 'campaign_update',
  },
  actions: {
    basic: {
      patch: 'patch_basic_ai_action',
      delete: 'delete_ai_action',
      duplicate: 'duplicate_ai_action',
      list: 'list_ai_actions',
      stats: 'get_ai_action_stats',
      health: 'get_ai_action_health',
      calls: 'get_ai_action_calls',
      skips: 'get_ai_action_skips',
      observed_metadata_keys: 'get_observed_metadata_keys',
    },
    httpRequest: {
      create: 'create_http_request_ai_action',
      get: 'get_http_request_ai_action',
      update: 'update_http_request_ai_action',
      test: 'test_http_request_ai_action',
      from_text: 'create_http_request_ai_action_from_text',
    },
    discordTemplates: {
      guilds: 'get_discord_template_guilds',
      resources: 'get_discord_template_guild_resources',
      install: 'install_discord_action_template',
    },
    shopifyMcp: {
      create: 'create_shopify_remote_mcp_ai_action',
      get: 'get_shopify_mcp_ai_action',
      update: 'update_shopify_mcp_ai_action',
      test: 'test_shopify_mcp_ai_action',
    },
    knowledgeBase: {
      create: 'create_knowledge_base_mcp_ai_action',
      get: 'get_knowledge_base_ai_action',
      update: 'update_knowledge_base_ai_action',
      test: 'test_knowledge_base_ai_action',
    },
    remoteMcp: {
      create: 'create_remote_mcp_ai_action',
      get: 'get_remote_mcp_ai_action',
      update: 'update_remote_mcp_ai_action',
      connect: 'test_remote_mcp_ai_action',
      oauthStart: 'start_remote_mcp_oauth',
      oauthDisconnect: 'disconnect_remote_mcp_oauth',
    },
  },
  remoteMcp: {
    create: 'create_remote_mcp',
    get: 'get_remote_mcp',
    patch: 'patch_remote_mcp',
  },
  handoff: {
    get: 'get_handoff',
    put: 'put_handoff',
  },
  shopify: {
    editorLink: 'shopify_editor_link',
    startOauth: 'shopify_start_oauth',
  },
  mcp: {
    get: 'get_mcp_settings',
    patch: 'patch_mcp_settings',
  },
  channelIdentity: {
    list: 'list_linked_channels',
    whatsappLink: 'start_whatsapp_channel_link',
    revoke: 'revoke_linked_channel',
  },
  inboxStatus: {
    general: 'get_inbox_status',
    my: 'get_my_inbox_status',
  },
  export: {
    conversations: 'export/conversations',
    conversationJob: 'export/conversations/job',
    dataGathering: 'export/data_gathering',
    linkTracking: 'export/link_tracking',
    aiInsights: 'export/ai_insights',
    triageData: 'export/triage_data',
    kbSources: 'export/kb_sources',
  },
  analytics: {
    general: 'get_dashboard_analytics',
    conversationRating: 'get_conversation_rating_analytics',
    linkTracking: 'get_link_tracking_analytics',
    kbSources: 'get_kb_sources_analytics',
    kbSourcesExamples: 'get_kb_sources_examples',
    userIntentDistribution: 'get_user_intent_distribution',
    unifiedInsightsList: 'get_unified_insights_list',
    setInsightReviewed: 'set_insight_reviewed',
    markAllInsightsReviewed: 'mark_all_insights_reviewed',
    unreadInsightsCount: 'get_unread_insights_count',
    sourceUrls: 'get_source_urls',
    externalCsat: 'get_external_csat_analytics',
    ttfr: 'get_ttfr_analytics',
  },
  conversationRatingConfiguration: {
    get: 'get_conversation_rating_configuration',
    patch: 'patch_conversation_rating_configuration',
    surveySettings: 'get_survey_settings',
    surveySettingsPatch: 'patch_survey_settings',
  },
  aiAssistants: {
    get: 'get_ai_assistants',
    patch: 'patch_scenario_id',
    dismissReviewPrompt: 'dismiss_review_prompt',
    clone: 'clone_ai_assistant',
    cloneStatus: 'clone_ai_assistant_status',
    cloneCheckout: 'clone_ai_assistant_checkout',
  },
  aiModel: {
    get: 'get_ai_model',
    patch: 'patch_ai_model',
  },
  implementation: {
    delete: 'delete_implementation',
  },
  scenarioUsers: {
    transferOwnership: 'transfer_scenario_ownership',
  },
  subscription: {
    usage: 'get_message_usage',
    creditTopup: 'get_credit_topup',
    creditTopupCheckout: 'post_credit_topup_checkout',
    creditTopupAutoReload: 'put_credit_topup_auto_reload',
    creditTopupCardSetup: 'post_credit_topup_card_setup',
  },
  integration: {
    publicUrl: 'patch_public_url',
    // Generic per-integration GET/PATCH keys used by all channel-integration
    // sheets. The query key tuple is `[QueryKey.integration.get, name]` so each
    // integration (discord, telegram, ...) gets its own cache slot.
    get: 'get_integration',
    patch: 'patch_integration',
    autoCloseMinutes: 'get_integration_auto_close_minutes',
    autoCloseMinutesPatch: 'patch_integration_auto_close_minutes',
    hubspotTokenStatus: 'get_hubspot_token_status',
    hubspotResolutionSurvey: 'get_hubspot_resolution_survey',
    hubspotResolutionSurveyPatch: 'patch_hubspot_resolution_survey',
    hubspotEmailReplyDelay: 'get_hubspot_email_reply_delay',
    hubspotEmailReplyDelayPatch: 'patch_hubspot_email_reply_delay',
    hubspotPipelines: 'get_hubspot_pipelines',
    hubspotPipelinesPatch: 'patch_hubspot_pipelines',
    hubspotWhatsappTemplate: 'get_hubspot_whatsapp_template',
    hubspotWhatsappTemplatePatch: 'patch_hubspot_whatsapp_template',
    hubspotOauthMutation: 'post_hubspot_oauth_url',
    googleSheetsStatus: 'get_google_sheets_status',
    googleSheetsOauthMutation: 'get_google_sheets_oauth_url',
    discordTokenStatus: 'get_discord_token_status',
    discordBotInfo: 'get_discord_bot_info',
    discordValidateToken: 'post_discord_validate_token',
    discordOauth: 'get_discord_oauth_url',
    discordGuilds: 'get_discord_guilds',
    discordGuildsHealth: 'get_discord_guilds_health',
    discordGuildPatch: 'patch_discord_guild',
    discordGuildDelete: 'delete_discord_guild',
    discordChannelToggle: 'patch_discord_channel',
    discordAutomatedMessageOptions: 'get_discord_automated_message_options',
    discordAutomatedMessagesUpdate: 'put_discord_automated_messages',
    discordAdvancedGuilds: 'get_discord_advanced_guilds',
    discordAdvancedAutomatedMessageOptions: 'get_discord_advanced_automated_message_options',
    discordAdvancedAutomatedMessagesUpdate: 'put_discord_advanced_automated_messages',
    telegramOneClickAvailability: 'get_telegram_one_click_availability',
    telegramConnectLink: 'post_telegram_connect_link',
    telegramChats: 'get_telegram_chats',
    telegramChatConfirm: 'post_telegram_chat_confirm',
    telegramChatPatch: 'patch_telegram_chat',
    telegramChatDelete: 'delete_telegram_chat',
    telegramDirectLink: 'get_telegram_direct_link',
    telegramDirectLinkPatch: 'patch_telegram_direct_link',
    telegramBotInfo: 'get_telegram_bot_info',
    intercomValidateToken: 'post_intercom_validate_token',
    intercomRemove: 'delete_intercom_integration',
    emailConnect: 'post_email_connect',
    emailReplyAddress: 'post_email_reply_address',
    emailVerifyDomain: 'post_email_verify_domain',
    emailSettings: 'post_email_settings',
    emailRemove: 'delete_email_integration',
    facebookMessengerDelete: 'delete_facebook_messenger',
    messengerOauthState: 'get_messenger_oauth_state',
    messengerPages: 'get_messenger_pages',
    messengerPageSelect: 'post_messenger_page_select',
    instagramOauthState: 'get_instagram_oauth_state',
    instagramDelete: 'delete_instagram_integration',
    slackV2Oauth: 'get_slackv2_oauth_url',
    slackV2Revoke: 'post_slackv2_revoke',
    zendeskGet: 'get_zendesk_integration',
    zendeskCreate: 'post_zendesk_integration',
    zendeskPatch: 'patch_zendesk_integration',
    zendeskDelete: 'delete_zendesk_integration',
  },
  apiTokens: {
    list: 'apiTokensList',
    create: 'createApiToken',
    revoke: 'revokeApiToken',
    legacyInfo: 'apiLegacyTokenInfo',
  },
  onboarding: {
    progress: 'onboarding_progress',
    skip: 'onboarding_skip',
    trackPageVisit: 'onboarding_track_page_visit',
    fromUrl: 'onboarding_from_url',
    fromDescription: 'onboarding_from_description',
    descriptionStatus: 'onboarding_description_status',
  },
  gettingStarted: {
    progress: 'getting_started_progress',
    discount: 'getting_started_progress_discount',
  },
  invites: {
    mine: 'my-invites',
    accept: 'accept-invite',
    ignore: 'ignore-invite',
    decline: 'decline-invite',
  },
  previewWebsite: {
    get: 'preview_website',
    refresh: 'preview_website_refresh',
  },
  conversationSources: 'conversation_sources',
  assistedOrders: {
    summary: 'assisted_orders_summary',
    recent: 'assisted_orders_recent',
    availability: 'assisted_orders_availability',
  },
  conversation: {
    sendMedia: 'conversation_send_media',
    createMessageFeedback: 'conversation_create_message_feedback',
    updateMessageFeedback: 'conversation_update_message_feedback',
    deleteMessageFeedback: 'conversation_delete_message_feedback',
  },
  conversationTopics: {
    list: 'conversation_topics_list',
    create: 'conversation_topics_create',
    update: 'conversation_topics_update',
    delete: 'conversation_topics_delete',
  },
  whatsappPhoneNumbers: {
    list: 'whatsapp_phone_numbers_list',
    toggle: 'whatsapp_phone_numbers_toggle',
    test: 'whatsapp_phone_numbers_test', // Pre-built for upcoming test-message UI
    delete: 'whatsapp_phone_numbers_delete',
    status: 'whatsapp_phone_numbers_status',
    oauthState: 'whatsapp_phone_numbers_oauth_state',
    pendingAccounts: 'whatsapp_phone_numbers_pending_accounts',
    pendingAccountSelect: 'whatsapp_phone_numbers_pending_account_select',
    pendingAccountCancel: 'whatsapp_phone_numbers_pending_account_cancel',
    oauthResult: 'whatsapp_phone_numbers_oauth_result',
    // Client-only cache key (no queryFn): tracks the optimistic "setup in
    // progress" window opened by a successful OAuth callback so the sheet can
    // render the in-progress banner and disable the connect actions until
    // the status query confirms 'connected'. Survives sheet close/reopen
    // during the ~20s Meta-call window.
    setupInProgress: 'whatsapp_phone_numbers_setup_in_progress',
  },
  app: {
    bootstrap: 'app_bootstrap',
    refreshJWT: 'app_refresh_jwt',
    supportIdentityToken: 'app_support_identity_token',
    pendingSupportReply: 'app_pending_support_reply',
    markSupportReplySeen: 'app_mark_support_reply_seen',
  },
  whatsappTemplates: {
    list: 'whatsapp_templates_list',
    send: 'whatsapp_templates_send',
    sendBulk: 'whatsapp_templates_send_bulk',
    validatePhones: 'whatsapp_templates_validate_phones',
  },
  simulation: {
    datasets: 'simulation_datasets',
    datasetDetail: 'simulation_dataset_detail',
    runs: 'simulation_runs',
    runDetail: 'simulation_run_detail',
    defaultEvaluationCriteria: 'simulation_default_evaluation_criteria',
    recentVisitorMessages: 'simulation_recent_visitor_messages',
    createDataset: 'simulation_create_dataset',
    updateDataset: 'simulation_update_dataset',
    deleteDataset: 'simulation_delete_dataset',
    addMessages: 'simulation_add_messages',
    uploadCsv: 'simulation_upload_csv',
    startRun: 'simulation_start_run',
    cancelRun: 'simulation_cancel_run',
  },
};
